// extracted by mini-css-extract-plugin
export var animationContainer = "_dw-0";
export var asteriskIcon = "_dw-8";
export var conversationLeftSection = "_dw-4";
export var conversationListItem = "_dw-3";
export var conversationMiddleSection = "_dw-5";
export var conversationRightSection = "_dw-6";
export var detailsContent = "_dw-1";
export var listContainer = "_dw-7";
export var modalContent = "_dw-2";